import { Box } from "@mui/material";
import { ReactNode } from "react";

import { TOOLBAR_CONTAINER } from "components/toolbars/constants";

/**
 * Static settings overview card shown when the tool settings button is toggled on.
 * Visibility is controlled by the caller.
 */
export function SettingsPanel({ children }: { children: ReactNode }) {
    return (
        <Box
            sx={{
                pointerEvents: "auto",
                borderRadius: `${TOOLBAR_CONTAINER.RADIUS}px`,
                backgroundColor: TOOLBAR_CONTAINER.BG,
                border: TOOLBAR_CONTAINER.BORDER,
                boxShadow: TOOLBAR_CONTAINER.SHADOW,
                width: "max-content",
                overflow: "hidden",
            }}
        >
            <Box
                sx={{
                    padding: "8px 16px",
                    display: "flex",
                    flexDirection: "column",
                }}
            >
                {children}
            </Box>
        </Box>
    );
}
